import React from "react";
import { BaseCalloutDescription } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function CalloutDescription(_ref) {
  var content = _ref.content,
    severity = _ref.severity,
    size = _ref.size,
    hideTitle = _ref.hideTitle;
  return /*#__PURE__*/_jsx(BaseCalloutDescription, {
    size: size,
    severity: severity,
    hideTitle: hideTitle,
    children: content
  });
}
export default CalloutDescription;